import { newDateFromUTC, newDateToUTC } from "@bc-library/common";
import { afterReceivingOne as afterReceivingOneInvoiceProject } from "../invoicingProjects/hooks";
import { afterReceivingOne as afterReceivingOneResourceResource } from "../resource/hooks";
import dayjs from "dayjs";

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return afterReceivingOne(object);
    });
  } else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => {
      return afterReceivingOne(object);
    });
  } else if (typeof data == "object") {
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT

export const afterReceivingOne = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      startDate: object.startDate && newDateFromUTC(object.startDate),
      endDate: object.endDate && newDateFromUTC(object.endDate),
      soldDate: object.soldDate && newDateFromUTC(object.soldDate),
      streams: object.streams && streamsFromUTC(object.streams),
      expectedCloseDate: object.expectedCloseDate && newDateFromUTC(object.expectedCloseDate),
      staffingSetup: object.staffingSetup && staffingSetupFromUTC(object.staffingSetup),
      myStaffingPeriods:
        object.myStaffingPeriods && staffingPeriodFromUTC(object.myStaffingPeriods),
      invoicesPopulated: object.invoicesPopulated
        ? object.invoicesPopulated.map((invoice: any) => {
            return afterReceivingOneInvoiceProject(invoice);
          })
        : object.invoicesPopulated,
      conditionalFees: object.conditionalFees
        ? object.conditionalFees.map((fee: any) => {
            return {
              ...fee,
              invoicingDate: fee.invoicingDate && newDateFromUTC(fee.invoicingDate),
              pickerDate: [dayjs(newDateFromUTC(fee.invoicingDate))],
            };
          })
        : object.conditionalFees,
    };
  }
  return object;
};

export const streamsFromUTC = (streams: any) => {
  return streams.map((stream: any) => ({
    ...stream,
    startDate: stream.startDate && newDateFromUTC(stream.startDate),
    endDate: stream.endDate && newDateFromUTC(stream.endDate),
  }));
};

export const afterReceivingChart = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      categories:
        object.categories &&
        object.categories.map((item: any) => {
          return {
            ...item,
            date: newDateFromUTC(item.date),
          };
        }),
    };
  }
  return object;
};

// OBJECT FIELDS

export const staffingSetupFromUTC = (staffingSetup: any) => {
  staffingSetup.forEach((setup: any) => {
    setup.list = setup.list.map((item: any) => {
      return {
        ...item,
        staffingPeriod: item.staffingPeriod && staffingPeriodFromUTC(item.staffingPeriod),
        resourceList: item.resourceList.map((resource: any) => {
          return {
            ...resource,
            resourceId:
              resource.resourceId && afterReceivingOneResourceResource(resource.resourceId),
          };
        }),
      };
    });
  });
  return staffingSetup;
};

export const staffingPeriodFromUTC = (staffingPeriod: any) => {
  staffingPeriod = staffingPeriod.map((period) => {
    return {
      ...period,
      startDate: period.startDate && newDateFromUTC(period.startDate),
      endDate: period.endDate && newDateFromUTC(period.endDate),
    };
  });
  return staffingPeriod;
};

// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return beforeSendingOne(object);
    });
  } else if (typeof data == "object") {
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      startDate: object.startDate && newDateToUTC(object.startDate),
      endDate: object.endDate && newDateToUTC(object.endDate),
      soldDate: object.soldDate && newDateToUTC(object.soldDate),
      expectedCloseDate: object.expectedCloseDate && newDateToUTC(object.expectedCloseDate),
      streams: object.streams && streamsToUTC(object.streams),
      staffingSetup: object.staffingSetup && staffingSetupToUTC(object.staffingSetup),
      conditionalFees: object.conditionalFees
        ? object.conditionalFees.map((fee: any) => {
            return {
              ...fee,
              invoicingDate: fee.invoicingDate && newDateToUTC(fee.invoicingDate),
            };
          })
        : object.conditionalFees,
    };
  }
  return object;
};

export const streamsToUTC = (streams: any) => {
  return streams.map((stream: any) => ({
    ...stream,
    startDate: stream.startDate && newDateToUTC(stream.startDate),
    endDate: stream.endDate && newDateToUTC(stream.endDate),
    managerId: stream.managerId?._id || stream.managerId || null,
  }));
};

export const beforeSendingList = (object: any) => {
  if (typeof object == "object") {
    return {
      ...object,
      staffingPeriod: object.staffingPeriod && staffingPeriodToUTC(object.staffingPeriod),
    };
  }
  return object;
};

// OBJECT FIELDS

export const staffingSetupToUTC = (staffingSetup: any) => {
  staffingSetup.forEach((setup: any) => {
    setup.list = setup.list.map((item: any) => {
      return {
        ...item,
        staffingPeriod: item.staffingPeriod && staffingPeriodToUTC(item.staffingPeriod),
      };
    });
  });
  return staffingSetup;
};

export const staffingPeriodToUTC = (staffingPeriod: any) => {
  staffingPeriod = staffingPeriod.map((period) => {
    return {
      ...period,
      startDate: period.startDate && newDateToUTC(period.startDate),
      endDate: period.endDate && newDateToUTC(period.endDate),
    };
  });
  return staffingPeriod;
};
